// Module
var code = "\n<div class=\"service-box\">\n  <div class=\"service-box-content\">\n    <div class=\"image-container\"><img ng-src=\"/assets/img/tmp/{{ form.image }}\"/></div>\n    <div class=\"text-container\"><span class=\"name\">Ihr Paket:</span><span class=\"value\">Privat 25</span></div>\n  </div>\n</div>\n";
// Exports
export default code;